// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import CopyCodeController from "./copy_code_controller"
application.register("copy-code", CopyCodeController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)
